import { Clickable, H3, P, Strong } from '@ahmdigital/ui';
import moment from 'moment';

import config from '../../config';
import constants from '../../ahm-constants';
import generator from './generator';
import styles from './styles.module.sass';

const platformList = `ahm.com.au, members.ahm.com.au and the ahm Mobile App`;
const lastUpdatedOn = '2023-04-03';

const bannerNote = (
  <>
    We reserve the right to amend the Terms and Conditions at any time. Your use of {platformList} constitute your
    agreement to be bound by these Terms and Conditions. These Terms and Conditions were last updated on{' '}
    {moment(lastUpdatedOn).format(constants.DATE_FORMAT.HUMAN)}. If you have any questions about these Terms and
    Conditions, you can <Clickable to={constants.URLS.SALES.CONTACT_US}>contact us</Clickable>.
  </>
);

const content = {
  description: `ahm health insurance is a business of Medibank Private Limited ABN 47 080 890 259. ‘ahm health insurance’
  and ‘ahm’, we, us and our are references to Medibank Private Ltd trading as ahm health insurance.`,
  note: bannerNote,
  sections: [
    {
      content: (
        <>
          <P>
            All information, text, materials, graphics and advertisements on {platformList} (‘Content’) are Copyright ©
            1998 – {new Date().getFullYear()} ahm health insurance, a business of Medibank Private Limited ABN 47 080
            890 259, its related bodies corporate, its suppliers and/or licensors unless expressly indicated otherwise
            on {platformList}.
          </P>
          <P>
            You must not modify, copy, reproduce, republish, frame, upload to a third party, post, transmit or
            distribute this Content in any way except as expressly provided for or expressly authorised in writing by us
            or our affiliates. Only on the condition that you keep all Content intact and in the same form as presented
            on {platformList} (including without limitation all copyright, trade mark and other proprietary notices and
            all advertisements), you may:
          </P>
          <ol type="a">
            <li>
              download and view the Content for your personal, non-commercial use using an industry-standard Web
              browser, or
            </li>
            <li>supply the Content to your subscriber if you are an Internet service and/or access provider.</li>
          </ol>
          <P>
            You must not use {platformList} in any manner or for any purpose which is unlawful or in any manner which
            violates any right of ours or an affiliate or which is prohibited by the Terms and Conditions.
          </P>
        </>
      ),
      id: 'copyright',
      title: 'Copyright',
    },
    {
      content: (
        <>
          <P>
            All trade marks displayed on {platformList} are trade marks of ahm, its related bodies corporate, or their
            respective owners. Nothing contained on {platformList} should be construed as granting any licence or right
            of use of any trade mark displayed on the Site without the express written permission of ahm, the relevant
            ahm affiliate or third party owner.
          </P>
          <P>
            Some of the trade marks may be available to you to place on your own website as a hyperlink to the relevant
            ahm website, but such use requires the express written authorisation of ahm or the relevant affiliate, and
            any use must be in accordance with the trade mark usage guidelines of the relevant trade mark owner.
          </P>
        </>
      ),
      id: 'trademarks',
      title: 'Trade marks',
    },
    {
      content: (
        <>
          <P>
            The Competition and Consumer Act 2010 and similar State and Territory Legislation in Australia may confer
            rights and remedies on you in relation to the provision by ahm and its related bodies corporate of goods or
            services on {platformList} which cannot be excluded, restricted or modified (‘Non-excludable Rights’). ahm
            does not exclude any Non-excludable Rights but does exclude all other conditions and warranties implied by
            custom, law or statute.
          </P>
          <P>Except as provided for by the Non-excludable Rights:</P>
          <ol type="a">
            <li>all Content is provided ‘as is’ and without warranties of any kind, either express or implied</li>
            <li>
              ahm, its related bodies corporate and its suppliers expressly disclaim all warranties of any kind
              including but not limited to implied warranties of merchantability and fitness for a particular purpose,
            </li>
            <li>
              ahm, its related bodies corporate do not warrant that the functions contained in any Content or any
              Communications Facility or your access to {platformList} will be uninterrupted or error-free, that any
              defects will be corrected or that {platformList} or the server which stores and transmits Content to you
              are free of viruses or any other harmful components,
            </li>
            <li>
              ahm and its related bodies corporate do not warrant or make any representation regarding your access to,
              or the results of your access to, {platformList} (including any related or linked website) or any Content
              in terms of correctness, accuracy, timeliness, completeness, reliability or otherwise; or
            </li>
            <li>
              you assume the entire cost of any necessary verification, maintenance, repair and/or correction of any
              relevant Content.
            </li>
          </ol>
          <P>
            Content on {platformList} is not intended to be used to diagnose, treat, cure or prevent any disease, and it
            should not be used for therapeutic purposes. You are responsible for assessing the accuracy and relevance of
            all Content.
          </P>
        </>
      ),
      id: ' consumer-law',
      title: 'Consumer Law',
    },
    {
      content: (
        <P>
          ahm has the sole right to determine your eligibility for access, the extent of your access and the level of
          services available via the Content. The range of services that ahm makes available to you through the Content
          may differ depending on the smartphone that you use. We may ask you to verify your identity to facilitate your
          access to all or part of the Content. The method of verifying your identity may include a multi-factor
          authentication layer. If you do not verify your identity, in the prescribed manner and when requested, you may
          not have access to all or part of the Content.
        </P>
      ),
      id: 'access',
      title: 'Access',
    },
    {
      content: (
        <>
          <P>
            Under no circumstances (including but not limited to any act or omission on the part of ahm) will ahm or its
            related bodies corporate be liable for any indirect, incidental, special and/or consequential damages or
            loss of profits whatsoever which result from any use or access of, or any inability to use or access,{' '}
            {platformList} or any Content.
          </P>
          <P>
            You expressly acknowledge and agree that ahm or its related bodies corporate does not exert control over
            users of {platformList} (including individuals referred to as guests and experts) and is not liable either
            for their opinions or their behaviour including any information and/or advice and any defamatory statements
            or offensive conduct.
          </P>
          <P>
            Subject to the Non-excludable Right, and otherwise to the fullest extent permitted by law, ahm’s liability
            and the liability of its related bodies corporate for breach of any implied warranty or condition which
            cannot be excluded is limited at the option of ahm and its related bodies corporate to the following:
          </P>
          <ol type="a">
            <li>
              in the case of services supplied or offered by ahm and its related bodies corporate:
              <ol>
                <li>the supply of the services again, or</li>
                <li>the payment of the cost of having services supplied again; and</li>
              </ol>
            </li>
            <li>
              in the case of goods supplied or offered by ahm and its related bodies corporate:
              <ol>
                <li>the replacement of the goods or the supply of equivalent goods,</li>
                <li>the repair of such goods,</li>
                <li>the payment of the cost of replacing the goods or acquiring equivalent goods; or</li>
                <li>the payment of the cost of having the goods repaired.</li>
              </ol>
            </li>
          </ol>
        </>
      ),
      id: 'limitation-of-liability',
      title: 'Limitation of liability',
    },
    {
      content: (
        <>
          <P>
            The Australian Government requires all health insurance providers and members to incorporate a program of
            fraud control as part of their overall risk management strategy. Our objective is to minimise loss from
            fraud so that we can maximise the amount available for benefit payments to you.
          </P>
          <P>
            We use an independent firm and our own teams to investigate suspected instances of fraud. Our aim is to
            recover any money and, more importantly, deter further fraudulent behaviour.
          </P>
          <P>
            The easiest way for you to help us is to simply be aware of what you are being billed for. Make sure the
            dates of service are correct and that you received the treatment recorded. It is also important to treat
            your member card like a debit or credit card, and not to leave it with any provider. If your card is lost,
            please report it to us straight away.
          </P>
          <P>
            If you have reason to suspect fraudulent activity, please complete{' '}
            <a href={constants.URLS.THIRD_PARTY.MEDIBANK_REPORT_FRAUD}>this form</a> with as much detail as possible.
            You can choose to remain anonymous but please be assured that we follow high standards of investigative
            practice and always protect the interests of all parties.
          </P>
        </>
      ),
      id: 'fraud',
      title: 'Fraud',
    },
    {
      content: (
        <>
          <P>
            The Terms and Conditions are governed by and construed in accordance with the laws of Victoria, Australia.
            You irrevocably and unconditionally submit to the non-exclusive jurisdiction of the courts of Victoria. If
            any provision of the Terms and Conditions is found to be invalid or unenforceable by a court of law, such
            invalidity or unenforceability will not affect the remainder of the Terms and Conditions, which will
            continue in full force and effect.
          </P>
          <P>
            {platformList} may be accessed throughout Australia and overseas. We make no representation that the Content
            or goods or services on {platformList} comply with the laws (including intellectual property laws) of any
            country outside of Australia. If you access {platformList} and the ahm Mobile App from outside Australia,
            you do so at your own risk and you are responsible for ensuring compliance with all laws in the place where
            you are located.
          </P>
        </>
      ),
      id: 'governing-law-and-jurisdiction',
      title: 'Governing law and jurisdiction',
    },
    {
      content: (
        <P>
          We will make all reasonable efforts to ensure that {platformList} are available 24 hours a day, 7 days a week.
          However, electronic services are subject to interruption or breakdown. Therefore, access is offered on an ‘as
          is’ and ‘as available’ basis only.
        </P>
      ),
      id: 'website-availability',
      title: 'Website availability',
    },
    {
      content: (
        <>
          <P>
            {platformList} contain hyperlinks and other pointers to internet websites operated by third parties. These
            linked websites are not under the control of ahm and ahm is not responsible for the contents of any linked
            website or any hyperlink contained in a linked website.
          </P>
          <P>
            ahm provides these hyperlinks to you as a convenience only and the inclusion of any link does not imply any
            endorsement of the linked website by ahm or its affiliates. You link to any such website entirely at your
            own risk.
          </P>
        </>
      ),
      id: 'links',
      title: 'Links',
    },
    {
      content: (
        <P>
          Your use of {platformList} is governed by our privacy policy which can be found here:{' '}
          <Clickable to={constants.URLS.SALES.PRIVACY}>{`${config.get('sales:url')}${
            constants.URLS.SALES.PRIVACY
          }`}</Clickable>
          .
        </P>
      ),
      id: 'privacy',
      title: 'Privacy',
    },
    {
      content: (
        <>
          <P>
            When you visit {platformList}, our servers collect routine logging information such as the pages visited,
            the time of your visit, the web browser that you are using and the IP address associated with your request.
            This information is used in aggregated form to help us manage our servers and websites and to improve our
            understanding of the needs of users. The information may also be used when investigating security incidents.
          </P>
          <P>
            {platformList} use cookies to enhance site functionality and user experience. You may use your browser
            preferences to disable cookies, but this will affect your experience of {platformList}.
          </P>
          <P>
            {platformList} use Google Analytics Premium and other third party tools to better understand how people uses
            these sites. This makes information similar to that of routine server logs available to Google or other
            third party statistics providers. The analytic reports that are produced are aggregated and do not identify
            individual people.
          </P>
          <P>
            Third party vendors, including Google, show ahm ads on websites across the internet. ahm uses third party
            cookies from Google to inform, report, optimise and serve ads based on visits to {platformList} via Google
            Advertising cookies. This is done using the following applications:
          </P>
          <ol type="a">
            <li>Remarketing with Google Analytics</li>
            <li>Google Display Network Impression Reporting</li>
            <li>DoubleClick Platform integrations</li>
            <li>Google Analytics Demographics and Interest Reporting</li>
          </ol>
          <P>
            If you would like more information about the above, including how to opt out of data being collected or used
            by the aforementioned third party cookies from Google, you can follow this link:{' '}
            <Clickable variant={styles.googleLink} to="https://www.google.com/intl/en/analytics/learn/privacy.html">
              https://www.google.com/intl/en/analytics/learn/privacy.html
            </Clickable>
          </P>
          <P>
            We collect and use some of the information you provide when you join ahm or when you access {platformList}{' '}
            by following a link on an ahm email. We use this information to:
          </P>
          <ul>
            <li>monitor the use of, and improve, the information and functions on {platformList}</li>
            <li>understand your interactions and preferences</li>
            <li>to provide you with information about products and services that may interest you</li>
          </ul>
          <P>
            This information may be linked to cookies set in your browser and to information you have provided to us
            previously. You may use your browser preferences to disable these cookies.
          </P>
          <P>
            Some ahm websites present content and functionality provided by third parties. The content, and any
            information gathered, is not controlled by ahm and users should consult the privacy policies of the third
            party providers. ahm will take reasonable steps to advise users when third parties are involved in ahm
            transactions.
          </P>
        </>
      ),
      id: 'cookie-policy',
      title: 'Cookie Policy',
    },
    {
      content: (
        <>
          <P>
            In order to access members.ahm.com.au and the ahm Mobile App, you must be the Principal Member and be
            registered.
          </P>
          <P>
            To use members.ahm.com.au and the ahm Mobile App, the Principal member is required to register and create
            login credentials. This may include an email address, password and additional authentication or verification
            steps. The same credentials will be used to access your account on both the App and members.ahm.com.au.
          </P>
          <P>
            The Principal member must take reasonable care to keep their password and any verification codes
            confidential and maintain accurate contact details associated with their account.
          </P>
          <P>The use of members.ahm.com.au and the ahm Mobile App may be subject to transaction limits, such as:</P>
          <ul>
            <li>the maximum amounts that may be submitted before any claims are processed and benefits paid</li>
            <li>the maximum amounts that may be paid subject to annual limits</li>
            <li>the maximum amounts for debit or credit card payments per transaction.</li>
          </ul>
        </>
      ),
      id: 'online-services-for-members',
      title: 'Online services for members',
    },
    {
      content: (
        <>
          <P>
            You may be required to verify your identity, using the prescribed method when requested, to make a claim on
            members.ahm.com.au or the ahm Mobile App. If you do not verify your identity, in the prescribed manner and
            when requested, you may not be able to make a claim on members.ahm.com.au or the ahm Mobile App.
          </P>
          <ol>
            <li>
              By submitting a claim via members.ahm.com.au and the ahm Mobile App, the Principal Member makes the
              following declaration:
              <ul>
                <li>
                  ‘I declare that I am the Principal Member on the membership. I acknowledge that claims for these
                  services may only be submitted by the Principal Member on the membership. I declare that the
                  information on this form is true and correct. I authorise ahm to check any of these services with the
                  relevant recognised provider and if any benefits have already been paid. I authorise ahm to use the
                  information on this claim form to assess and process this claim, or for any other purposes as outlined
                  in the Terms and Conditions and the Privacy Policy.’
                </li>
              </ul>
            </li>
            <li>
              Only the Principal Member can submit selected extras claims relevant to themselves and any Partner, Adult
              / Student Dependent or Dependent under the age of 16 on the membership via members.ahm.com.au and the ahm
              Mobile App. The <a href={constants.URLS.SALES.TERMS_AND_CONDITIONS}>Terms and Conditions</a> and{' '}
              <a href={constants.URLS.SALES.PRIVACY}>Privacy Policy</a> also apply to claims submitted via
              members.ahm.com.au and the ahm Mobile App.
            </li>

            <li>
              Each time you lodge a claim via members.ahm.com.au and the ahm Mobile App, you are declaring and agreeing
              that:
              <ol type="a">
                <li>
                  all information supplied in connection with the claim is true, correct and supported by valid invoices
                  or receipts;
                </li>
                <li>
                  benefits are not payable by the Fund in relation to any service until you have paid the provider of
                  the service in full for the service.
                </li>
                <li>
                  you’ll need to keep original receipts for 3 years for audit purposes, unless you have attached a clear
                  image of the full invoice or receipt with your claim;
                </li>
                <li>
                  if the image provided is not clear or does not show the full receipt or invoice, you may be required
                  to provide another copy;
                </li>
                <li>
                  you may be asked to produce relevant invoices or receipts prior to finalising the assessment of any
                  claim and prior to the payment of any benefit;
                </li>
                <li>
                  if your claims have been selected for audit:
                  <ol>
                    <li>you will provide up to 3 years of invoices and receipts within 14 days of any request;</li>
                    <li>
                      benefits payable to you can be held until the valid invoices and receipts are received and
                      verified by the Fund;
                    </li>
                    <li>
                      your ability to make a claim via members.ahm.com.au and the ahm Mobile App will be suspended until
                      a time when claims can be verified;
                    </li>
                    <li>
                      a refund of any benefits paid may be sought if a claim cannot be substantiated by valid invoices
                      and receipts;
                    </li>
                    <li>
                      the Fund reserves the right to recover any overpayment of any claim which cannot be substantiated
                      from any future claims or premium refunds;
                    </li>
                    <li>
                      if you do not produce valid invoices and receipts, your claim can be deemed invalid, access to
                      members.ahm.com.au and the ahm Mobile App be removed or your membership with the Fund can be
                      terminated.{' '}
                    </li>
                  </ol>
                </li>
                <li>the Fund does not guarantee a response or payment of benefits within any particular period;</li>
                <li>
                  the successful lodgement of a claim via members.ahm.com.au and the ahm Mobile App does not guarantee
                  the payment of any benefit. The payment of benefits is at all times subject to the Fund Rules and
                  policies as amended from time to time^;
                </li>
                <li>
                  if the claim has been paid in full, any benefits payable in respect of the claim will be paid to the
                  policy holder of your policy in their nominated bank account. If the claim has not been paid in full,
                  any benefits payable in respect of the claim will be paid to the provider of the service that is the
                  subject of the claim;
                </li>
                <li>
                  you authorise any health service provider to give the Fund any information as may be necessary to
                  assess the claim;
                </li>
                <li>
                  the expenses detailed in the claim are not, and will not be subject to a compensation or damages
                  claim*;
                </li>
                <li>
                  you will inform the Fund immediately if you become aware that any details of the claim are incorrect;
                </li>
                <li>
                  the services described in the claim were actually provided and received from a Recognised Provider #;
                </li>
                <li>
                  you have the facilities to access and receive electronic communications (e.g. email) regarding the
                  claim and will regularly check to access and view such communications. A communication will not under
                  any circumstances be treated as invalid by virtue of any delay or omission by you to access and view
                  it after it is received at your designated electronic system or address;
                </li>
                <li>
                  A daily benefit limit of $1,000 per membership applies to claims submitted via members.ahm.com.au and
                  the ahm Mobile App.
                </li>
                <li>
                  The membership premiums must be up to date as at the time of receiving the service to receive any
                  benefits back for claims submitted via members.ahm.com.au and the ahm Mobile App.
                </li>
                <li>
                  To the maximum extent permitted by law, ahm (together with its related entities, employees, agents,
                  contractors and suppliers) (“ahm Protected Parties”) accept no responsibility, and will not be liable
                  or responsible in tort (including negligence), contract or statute to you or any other person for any
                  loss, damages, costs, expenses, injuries or other claims (including consequential loss or damage, loss
                  of profits or anticipated profits, loss of revenues, economic loss or loss of opportunity), as a
                  result (direct or indirect) of any defect, deficiency or discrepancy in the online claims service via
                  members.ahm.com.au and the ahm Mobile App (including its form, content and timeliness of delivery).
                </li>
                <li>
                  The Competition and Consumer Act 2010 and certain State and Territory legislation may confer certain
                  guarantees, conditions and warranties into these terms which cannot be excluded, restricted or
                  modified (’Non-excludable Rights’). ahm does not exclude any Non-excludable Rights, but does exclude
                  all other conditions and warranties implied by custom, law or statute. Subject to the Non-excludable
                  Rights, and otherwise to the maximum extent permitted by law, the liability of ahm and the ahm
                  Protected Parties (if any) arising from the breach of any implied condition or warranty which cannot
                  be excluded is limited at the option of ahm and its related bodies corporate to the following:
                  <ol>
                    <li>
                      in the case of goods;
                      <ol>
                        <li>the replacement of the goods or the supply of equivalent goods;</li>
                        <li>the repair of the goods;</li>
                        <li>the payment of the cost of replacing the goods or of acquiring equivalent goods; or</li>
                        <li>the payment of the cost of having the goods repaired; and</li>
                      </ol>
                    </li>
                    <li>
                      in the case of services, supplying the services again or payment of the cost of having the
                      services supplied again.
                    </li>
                  </ol>
                </li>
                <li>
                  To the extent that a provision in these terms is expressed to be for the benefit of any ahm Protected
                  Party, where a contract or agreement incorporates these terms, ahm health insurance enters into that
                  contract or agreement in its own capacity and in its capacity as trustee and agent for that ahm
                  Protected Party, and ahm health insurance is entitled to enforce that provision for the benefit of
                  itself and for the benefit of that ahm Protected Party.
                </li>
              </ol>
            </li>
          </ol>
          <P variant="em">
            ^ Terms and conditions of membership are contained in the Fund Rules. You can view a copy of the Fund Rules
            online at ahm.com.au. Rules and benefit levels may change from time to time. If you anticipate treatment or
            a procedure for which you are expecting a benefit from the Fund, please contact us before commencing
            treatment to establish whether the benefit you expect will be paid.
          </P>
          <P variant="em">
            * Benefits are not payable where the relevant member has, or may have, an entitlement to receive
            compensation or damages. In such circumstances, the Fund expects that the relevant member will pursue that
            entitlement. The Fund may make provisional benefit payments on application, subject to our Fund Rules and
            policies, but the relevant member must agree to repay such payments, in full, from their final settlement.
            If a claim for which benefits have been paid appears at a later point in time to be one in respect of which
            an entitlement to compensation or damages exists, the Fund reserves the right to recover the amount of
            benefits paid.
          </P>
          <P variant="em">
            # A recognised provider is a health provider whose services are recognised for the payment of benefits by
            Medibank.
          </P>
        </>
      ),
      id: 'making-a-claim',
      title: 'Making a claim on members.ahm.com.au or the ahm Mobile App',
    },
    {
      content: (
        <>
          <P>
            ahm Health Insurance Chat is a service established and maintained by ahm Health Insurance, a business of
            Medibank Private Limited ACN 080 890 259, which enables you to chat to an ahm Health Insurance consultant in
            real-time to assist you to navigate your way around ahm Health Insurance’s website and, where possible,
            discuss your ahm health insurance cover. The ahm Health Insurance Chat facility uses{' '}
            <Strong>LivePerson Inc’s </Strong>
            engagement technology.
          </P>
          <P>
            These Terms of Use govern your access to and use of ahm Health Insurance Chat and contain important
            information, including disclaimers and limitations of liability. Your use of ahm Health Insurance Chat
            constitutes acceptance of these Terms of Use.
          </P>

          <H3 looksLike="h5">Eligibility for access</H3>
          <P>
            ahm Health Insurance Chat is intended solely for use by Australian residents and holders of valid Australian
            visas who are eligible to purchase our insurance products. To be eligible to use ahm Health Insurance Chat
            you must be 16 years of age or older. ahm Health Insurance has the sole right to determine your eligibility
            for, and the extent of your access to, ahm Health Insurance Chat.
          </P>

          <H3 looksLike="h5">Appropriate use of ahm Health Insurance Chat</H3>
          <P>
            You must only use ahm Health Insurance Chat for the purposes described in these Terms of Use. You must not
            use or attempt to use ahm Health Insurance Chat to:
          </P>
          <ol>
            <li>
              corrupt, damage or interfere with ahm Health Insurance Chat or any ahm Health Insurance or third party
              data, software, hardware, website or information technology systems;
            </li>
            <li>
              send any offensive, inflammatory, defamatory, fraudulent or otherwise unlawful information or information
              that infringes third party rights;
            </li>
            <li>adversely affect the reputation or public image of ahm Health Insurance; or</li>
            <li>cause annoyance or inconvenience to ahm Health Insurance or any third party.</li>
          </ol>
          <P>
            You acknowledge that ahm Health Insurance can terminate your use of ahm Health Insurance Chat if ahm Health
            Insurance reasonably believes that you have breached these Terms of Use.
          </P>

          <H3 looksLike="h5">Communications</H3>
          <P>
            During your Chat with an ahm Health Insurance consultant, you may provide personal information including
            your:
          </P>

          <ol>
            <li>email address if you would like ahm Health Insurance to email correspondence to you;</li>
            <li>
              telephone number if you would like an ahm Health Insurance consultant to contact you following the Chat to
              resolve any outstanding issues you may have or for follow up purposes; and/or
            </li>
            <li>postal address if you would like ahm Health Insurance to post correspondence to you.</li>
          </ol>
          <P>
            {' '}
            In providing ahm Health Insurance your email address, telephone number and/or your postal address, you
            consent to ahm Health Insurance using your email address and/or telephone number to contact you for the
            above purposes.
          </P>

          <H3 looksLike="h5">Privacy</H3>
          <P>
            Any personal information (including sensitive information) <Strong>(Information)</Strong> you provide during
            the Chat will be collected by ahm Health Insurance in its capacity as the Chat service provider and
            LivePerson in its capacity as the communications technology provider.
          </P>
          <P>
            ahm Health Insurance and LivePerson each handle the Information they collect about you in accordance with
            their respective privacy policies, which you can access via the following links:
          </P>

          <H3 looksLike="h5">ahm Health Insurance’s Privacy Policy</H3>
          <P>
            <Clickable to={constants.URLS.SALES.PRIVACY}>{`${config.get('sales:url')}${
              constants.URLS.SALES.PRIVACY
            }`}</Clickable>
          </P>

          <H3 looksLike="h5">LivePerson’s Customer Website Privacy Policy</H3>
          <P>
            <Clickable to="http://www.liveperson.com/policies/customer-website-privacy">
              http://www.liveperson.com/policies/customer-website-privacy
            </Clickable>
          </P>
          <P>
            If you provide your Information as part of the ahm Health Insurance Chat, it will be collected and used for
            the purposes outlined in ahm Health Insurance’s Privacy Policy and to provide you with the ahm Health
            Insurance Chat service including to:
          </P>
          <ol>
            <li>assist you to navigate the ahm Health Insurance website;</li>
            <li>
              answer your queries or resolve any issues you may have regarding ahm Health Insurance’s products and
              services;
            </li>
            <li>
              answer your queries or resolve any issues you may have regarding your ahm Health Insurance’s cover; and
            </li>
            <li>
              continue to develop and improve the ahm Health Insurance Chat service, the ahm Health Insurance website
              and ahm Health Insurance’s products and services.
            </li>
          </ol>
          <P>
            In order to provide the Chat service, ahm Health Insurance and LivePerson may disclose your Information to
            third parties, including technology maintenance and support services providers. These providers may be
            located, or provide services from, overseas including in the United Kingdom, the United States of America,
            Israel and the Netherlands.
          </P>
          <P>
            You may choose to access and use ahm Health Insurance Chat on an anonymous basis and/or nominate an alias
            for use by the ahm Health Insurance consultant during your Chat. However, this may mean that ahm Health
            Insurance is only able to provide you with general advice and assistance during the Chat.
          </P>
          <P>
            ahm Health Insurance’s Privacy Policy contains more information about its privacy practices, including how
            you can request access to, or correction of, personal information held about you, how you can lodge a
            privacy complaint and how such complaints are managed.
          </P>
          <P>
            If you provide Information about another person as part of the Chat, you must ensure that, prior to
            providing the Information about that person, the person is aware of how their Information will be handled
            under these Terms of Use and that they consent to the handling of their Information in accordance with these
            Terms of Use.
          </P>

          <H3 looksLike="h5">Intellectual property rights</H3>
          <P>
            You acknowledge that all intellectual property rights (including copyright) in the content, layout, design,
            concept, graphics, software and organisation of ahm Health Insurance Chat including the transcripts of any
            Chat (ahm Health Insurance Materials) is owned by or licensed to ahm Health Insurance. Solely to the extent
            required for you to use our services, ahm Health Insurance grants you a non-exclusive, revocable licence to
            use the ahm Health Insurance Materials for your personal use in accordance with these Terms of Use. You may
            not otherwise use, copy, change, communicate, sell or otherwise deal with the ahm Health Insurance
            Materials. ahm Health Insurance will own all rights in the content that you enter into ahm Health Insurance
            Chat. All ahm Health Insurance trade marks, logos and other proprietary graphics may not be used in
            connection with any other product or service without ahm Health Insurance’s express prior written consent.
          </P>

          <H3 looksLike="h5">Disclaimers</H3>
          <P>
            ahm Health Insurance Chat is provided to you on ‘as is’ and ‘as available’ basis and may, from time to time,
            contain errors, faults and inaccuracies. Subject to the consumer guarantees provided for in consumer
            protection legislation (including the Australian Consumer Law), ahm Health Insurance makes no representation
            and provides no express or implied warranty or guarantee about the security of ahm Health Insurance Chat,
            the safety of any file or software associated with it (such as safety from any virus or defects including
            those that could damage or interfere with any data, software or hardware with which it might be used) or
            that access to ahm Health Insurance Chat will be uninterrupted or fault free. ahm Health Insurance does not
            provide telecommunications services and does not warrant that you will have continuous access to ahm Health
            Insurance Chat or that it will be supplied fault free. ahm Health Insurance will not be liable in the event
            that ahm Health Insurance Chat is unavailable to you for any reason including due to computer downtime
            attributable to malfunctions, upgrades, preventative or remedial maintenance activities or interruption in
            telecommunications supply. ahm Health Insurance reserves the right to suspend or terminate the availability
            of ahm Health Insurance Chat at any time.
          </P>
          <P>
            Any response provided by an ahm Health Insurance consultant through ahm Health Insurance Chat is provided
            for information purposes only. Subject to the consumer guarantees provided for in consumer protection
            legislation (including the Australian Consumer Law), ahm Health Insurance does not give any express or
            implied warranties and makes no representations in relation to the responses provided by an ahm Health
            Insurance consultant through ahm Health Insurance Chat. While reasonable care has been taken in its
            preparation, ahm Health Insurance does not guarantee or warrant the accuracy, quality, completeness,
            reliability or currency of the responses provided by an ahm Health Insurance consultant through ahm Health
            Insurance Chat or of any ahm Health Insurance websites, materials, information, products or services
            promoted through ahm Health Insurance Chat, or their usefulness in achieving any purpose. You should make
            and rely on your own assessment and enquiries to verify the accuracy of the information provided through ahm
            Health Insurance Chat.
          </P>

          <P>
            You agree to access and use ahm Health Insurance Chat entirely at your own risk including in relation to all
            information that you choose to transmit through ahm Health Insurance Chat.
          </P>

          <H3 looksLike="h5">Limitation of liability</H3>
          <P>
            Subject to the consumer guarantees provided for in consumer protection legislation (including the Australian
            Consumer Law), ahm Health Insurance and its officers, employees and agents accept no liability for any loss,
            damage, illness or injury (including any loss of profits or income, business interruption or loss or
            corruption of data or other information):
          </P>

          <ol>
            <li>
              arising from:
              <ul>
                <li>your access to or use of ahm Health Insurance Chat;</li>
                <li>the information on ahm Health Insurance Chat being incorrect, incomplete or misleading;</li>
                <li>
                  any action or indecision by you in reliance of the information contained in ahm Health Insurance Chat;
                  and
                </li>
                <li>any delay or interruption in access to or use of ahm Health Insurance Chat; and</li>
              </ul>
            </li>
            <li>
              for any personal injury, including death, caused by access to, use or misuse of ahm Health Insurance Chat
              including its content and services.
            </li>
          </ol>

          <H3 looksLike="h5">Indemnity</H3>
          <P>
            {' '}
            You agree to defend, indemnify and hold harmless ahm Health Insurance and its officers, directors, employees
            and agents from and against all claims, actions, loss, damages, liabilities and costs related to or arising
            directly or indirectly from the following:
          </P>
          <ol>
            <li>any breach by you of these Terms of Use; and</li>
            <li>
              subject to the consumer guarantees provided for in consumer protection legislation (including the
              Australian Consumer Law), your use of ahm Health Insurance Chat.
            </li>
          </ol>

          <H3 looksLike="h5">Chat cookies</H3>
          <P>
            If your web browser is set up to accept cookies, a cookie will be stored on your hard drive when you visit
            ahm Health Insurance’s website. Cookies allow ahm Health Insurance to collect information about your
            computer, which may include your IP address (a number assigned to your computer when you register with an
            Internet Service Provider), type of browser, operating system, domain name, and the details of any website
            which has referred you to this website. ahm Health Insurance uses cookies to track and collect information
            about whether you have been invited to chat in a session on ahm Health Insurance Chat already. Cookies will
            also allow ahm Health Insurance to recognise your computer while you are on ahm Health Insurance Chat.
          </P>
          <P>
            If you would rather not have this information stored on your computer, you can configure your browser so it
            does not accept cookies. However, if you disable cookies you will not be able to access ahm Health Insurance
            Chat.
          </P>

          <H3 looksLike="h5">Other terms and conditions</H3>
          <P>
            These Terms of Use are in addition to all other terms relating to your use of ahm Health Insurance’s website
            available at:{' '}
            <Clickable to={constants.URLS.SALES.TERMS_AND_CONDITIONS}>{`${config.get('sales:url')}${
              constants.URLS.SALES.TERMS_AND_CONDITIONS
            }`}</Clickable>
          </P>

          <H3 looksLike="h5">General</H3>
          <P>
            If the whole or any part of these Terms of Use are invalid, unenforceable, illegal, void or voidable for any
            reason, these Terms of Use will be construed and be binding as if the invalid, unenforceable, illegal, void
            or voidable part had been deleted from them or read down to the extent necessary to overcome the difficulty.
          </P>
          <P>
            A waiver by ahm Health Insurance of any breach or a failure to enforce or to insist on the observance of a
            condition of these Terms of Use will not be a waiver of any other or of any subsequent breach.
          </P>
          <P>
            ahm Health Insurance will not be responsible or liable for failure to perform any obligation under these
            Terms of Use if such failure is caused by the occurrence of any matter beyond its reasonable control
            including, without limitation, internet and communications outages, fire, flood, war, or act of God.
          </P>
          <P>
            These Terms of Use are governed by the laws in force in the State of Victoria, Australia. Both you and ahm
            Health Insurance irrevocably submit to the non-exclusive jurisdiction of the courts of that State and all
            courts with jurisdiction to hear appeals from those courts.
          </P>
          <P>
            These Terms of Use may be updated from time to time without notice. Please visit this page for the most
            current version of the Terms of Use.
          </P>
          <P>These Terms of Use were last updated on {moment(lastUpdatedOn).format(constants.DATE_FORMAT.HUMAN)}.</P>
        </>
      ),
      id: 'chat-terms-of-use',
      title: 'Chat Terms of Use',
    },
  ],
  title: 'Terms and Conditions',
};

export default generator(content);
